import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { tours, saveTours } from "../data/Tours";
import Navbar from "./Navbar";
import Footer from "./Footer";

// Učitaj ažurirane podatke
const getTours = () => {
  const saved = localStorage.getItem("travelina_tours");
  if (saved) {
    try {
      return JSON.parse(saved);
    } catch (e) {
      return tours;
    }
  }
  return tours;
};

const TOUR_TITLES = {
  valladolid: {
    hr: "Valladolid",
    en: "Valladolid",
    de: "Valladolid",
    es: "Valladolid",
  },
  alicante: {
    hr: "Alicante",
    en: "Alicante",
    de: "Alicante",
    es: "Alicante",
  },
};

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [localTours, setLocalTours] = useState(getTours());
  const [editingTour, setEditingTour] = useState(null);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    // Provjeri autentifikaciju
    const isAuth = localStorage.getItem("travelina_admin_auth");
    if (!isAuth) {
      navigate("/admin/login");
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("travelina_admin_auth");
    navigate("/admin/login");
  };

  const handleEdit = (tour) => {
    setEditingTour({ ...tour });
  };

  const handleSave = () => {
    const updatedTours = localTours.map((tour) =>
      tour.id === editingTour.id ? editingTour : tour
    );
    setLocalTours(updatedTours);
    saveTours(updatedTours);
    setEditingTour(null);
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
    // Reload stranice da se promjene primijene
    window.location.reload();
  };

  const handleCancel = () => {
    setEditingTour(null);
  };

  const handleChange = (field, value) => {
    setEditingTour({ ...editingTour, [field]: value });
  };

  const handleBlogTextChange = (lang, value) => {
    setEditingTour({
      ...editingTour,
      blogText: {
        ...editingTour.blogText,
        [lang]: value,
      },
    });
  };

  if (editingTour) {
    return (
      <div className="app">
        <Navbar />
        <main>
          <section className="section" style={{ paddingTop: "6rem" }}>
            <div className="container">
              <div style={{ marginBottom: "2rem" }}>
                <button
                  onClick={handleCancel}
                  style={{
                    padding: "0.5rem 1rem",
                    background: "rgba(148, 163, 184, 0.2)",
                    border: "1px solid rgba(148, 163, 184, 0.35)",
                    borderRadius: "0.5rem",
                    color: "#e5e7eb",
                    cursor: "pointer",
                    marginRight: "1rem",
                  }}
                >
                  ← Natrag
                </button>
                <button
                  onClick={handleSave}
                  style={{
                    padding: "0.5rem 1rem",
                    background: "#f97316",
                    border: "none",
                    borderRadius: "0.5rem",
                    color: "#111827",
                    cursor: "pointer",
                    fontWeight: "600",
                  }}
                >
                  Spremi promjene
                </button>
              </div>

              <div
                style={{
                  background: "rgba(15, 23, 42, 0.96)",
                  padding: "2rem",
                  borderRadius: "1.5rem",
                  border: "1px solid rgba(148, 163, 184, 0.35)",
                }}
              >
                <h2 style={{ marginBottom: "1.5rem" }}>
                  Uređivanje: {TOUR_TITLES[editingTour.key]?.hr || editingTour.key}
                </h2>

                <div style={{ display: "grid", gap: "1.5rem" }}>
                  <div>
                    <label
                      style={{
                        display: "block",
                        marginBottom: "0.5rem",
                        color: "#9ca3af",
                      }}
                    >
                      Kategorija
                    </label>
                    <select
                      value={editingTour.category}
                      onChange={(e) => handleChange("category", e.target.value)}
                      style={{
                        width: "100%",
                        padding: "0.75rem",
                        background: "rgba(2, 6, 23, 0.8)",
                        border: "1px solid rgba(148, 163, 184, 0.35)",
                        borderRadius: "0.5rem",
                        color: "#e5e7eb",
                      }}
                    >
                      <option value="city">Gradovi</option>
                      <option value="beach">More</option>
                      <option value="adventure">Avantura</option>
                      <option value="romantic">Romantično</option>
                    </select>
                  </div>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
                    <div>
                      <label
                        style={{
                          display: "block",
                          marginBottom: "0.5rem",
                          color: "#9ca3af",
                        }}
                      >
                        Dana
                      </label>
                      <input
                        type="number"
                        value={editingTour.days}
                        onChange={(e) => handleChange("days", parseInt(e.target.value))}
                        style={{
                          width: "100%",
                          padding: "0.75rem",
                          background: "rgba(2, 6, 23, 0.8)",
                          border: "1px solid rgba(148, 163, 184, 0.35)",
                          borderRadius: "0.5rem",
                          color: "#e5e7eb",
                        }}
                      />
                    </div>
                    <div>
                      <label
                        style={{
                          display: "block",
                          marginBottom: "0.5rem",
                          color: "#9ca3af",
                        }}
                      >
                        Noćenja
                      </label>
                      <input
                        type="number"
                        value={editingTour.nights}
                        onChange={(e) => handleChange("nights", parseInt(e.target.value))}
                        style={{
                          width: "100%",
                          padding: "0.75rem",
                          background: "rgba(2, 6, 23, 0.8)",
                          border: "1px solid rgba(148, 163, 184, 0.35)",
                          borderRadius: "0.5rem",
                          color: "#e5e7eb",
                        }}
                      />
                    </div>
                  </div>

                  <div>
                    <label
                      style={{
                        display: "block",
                        marginBottom: "0.5rem",
                        color: "#9ca3af",
                      }}
                    >
                      Država
                    </label>
                    <input
                      type="text"
                      value={editingTour.country}
                      onChange={(e) => handleChange("country", e.target.value)}
                      style={{
                        width: "100%",
                        padding: "0.75rem",
                        background: "rgba(2, 6, 23, 0.8)",
                        border: "1px solid rgba(148, 163, 184, 0.35)",
                        borderRadius: "0.5rem",
                        color: "#e5e7eb",
                      }}
                    />
                  </div>

                  <div>
                    <label
                      style={{
                        display: "block",
                        marginBottom: "0.5rem",
                        color: "#9ca3af",
                      }}
                    >
                      Datum
                    </label>
                    <input
                      type="date"
                      value={editingTour.date}
                      onChange={(e) => handleChange("date", e.target.value)}
                      style={{
                        width: "100%",
                        padding: "0.75rem",
                        background: "rgba(2, 6, 23, 0.8)",
                        border: "1px solid rgba(148, 163, 184, 0.35)",
                        borderRadius: "0.5rem",
                        color: "#e5e7eb",
                      }}
                    />
                  </div>

                  <div>
                    <label
                      style={{
                        display: "block",
                        marginBottom: "0.5rem",
                        color: "#9ca3af",
                      }}
                    >
                      Cijena (€)
                    </label>
                    <input
                      type="number"
                      value={editingTour.price}
                      onChange={(e) => handleChange("price", parseInt(e.target.value))}
                      style={{
                        width: "100%",
                        padding: "0.75rem",
                        background: "rgba(2, 6, 23, 0.8)",
                        border: "1px solid rgba(148, 163, 184, 0.35)",
                        borderRadius: "0.5rem",
                        color: "#e5e7eb",
                      }}
                    />
                  </div>

                  <div>
                    <label
                      style={{
                        display: "block",
                        marginBottom: "0.5rem",
                        color: "#9ca3af",
                      }}
                    >
                      Tag
                    </label>
                    <input
                      type="text"
                      value={editingTour.tag}
                      onChange={(e) => handleChange("tag", e.target.value)}
                      style={{
                        width: "100%",
                        padding: "0.75rem",
                        background: "rgba(2, 6, 23, 0.8)",
                        border: "1px solid rgba(148, 163, 184, 0.35)",
                        borderRadius: "0.5rem",
                        color: "#e5e7eb",
                      }}
                    />
                  </div>

                  <div>
                    <label
                      style={{
                        display: "block",
                        marginBottom: "0.5rem",
                        color: "#9ca3af",
                      }}
                    >
                      Slika (putanja)
                    </label>
                    <input
                      type="text"
                      value={editingTour.image}
                      onChange={(e) => handleChange("image", e.target.value)}
                      style={{
                        width: "100%",
                        padding: "0.75rem",
                        background: "rgba(2, 6, 23, 0.8)",
                        border: "1px solid rgba(148, 163, 184, 0.35)",
                        borderRadius: "0.5rem",
                        color: "#e5e7eb",
                      }}
                    />
                  </div>

                  <div style={{ marginTop: "2rem" }}>
                    <h3 style={{ marginBottom: "1rem" }}>Blog tekstovi</h3>
                    {["hr", "en", "de", "es"].map((lang) => (
                      <div key={lang} style={{ marginBottom: "1.5rem" }}>
                        <label
                          style={{
                            display: "block",
                            marginBottom: "0.5rem",
                            color: "#9ca3af",
                            textTransform: "uppercase",
                          }}
                        >
                          {lang === "hr" ? "Hrvatski" : lang === "en" ? "English" : lang === "de" ? "Deutsch" : "Español"}
                        </label>
                        <textarea
                          value={editingTour.blogText?.[lang] || ""}
                          onChange={(e) => handleBlogTextChange(lang, e.target.value)}
                          rows={8}
                          style={{
                            width: "100%",
                            padding: "0.75rem",
                            background: "rgba(2, 6, 23, 0.8)",
                            border: "1px solid rgba(148, 163, 184, 0.35)",
                            borderRadius: "0.5rem",
                            color: "#e5e7eb",
                            fontFamily: "inherit",
                            resize: "vertical",
                          }}
                          placeholder={`Unesite blog tekst na ${lang === "hr" ? "hrvatskom" : lang === "en" ? "engleskom" : lang === "de" ? "njemačkom" : "španjolskom"} jeziku...`}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="app">
      <Navbar />
      <main>
        <section className="section" style={{ paddingTop: "6rem" }}>
          <div className="container">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "2rem",
              }}
            >
              <h1>Admin Dashboard</h1>
              <button
                onClick={handleLogout}
                style={{
                  padding: "0.5rem 1rem",
                  background: "rgba(239, 68, 68, 0.2)",
                  border: "1px solid rgba(239, 68, 68, 0.5)",
                  borderRadius: "0.5rem",
                  color: "#ef4444",
                  cursor: "pointer",
                }}
              >
                Odjava
              </button>
            </div>

            {saved && (
              <div
                style={{
                  padding: "1rem",
                  background: "rgba(34, 197, 94, 0.2)",
                  border: "1px solid rgba(34, 197, 94, 0.5)",
                  borderRadius: "0.5rem",
                  color: "#22c55e",
                  marginBottom: "1rem",
                }}
              >
                Promjene su spremljene!
              </div>
            )}

            <div style={{ display: "grid", gap: "1.5rem" }}>
              {localTours.map((tour) => (
                <div
                  key={tour.id}
                  style={{
                    background: "rgba(15, 23, 42, 0.96)",
                    padding: "1.5rem",
                    borderRadius: "1.5rem",
                    border: "1px solid rgba(148, 163, 184, 0.35)",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <h3>{TOUR_TITLES[tour.key]?.hr || tour.key}</h3>
                    <p style={{ color: "#9ca3af", fontSize: "0.9rem" }}>
                      {tour.country} · {tour.days} dana / {tour.nights} noćenja · {tour.price}€
                    </p>
                  </div>
                  <button
                    onClick={() => handleEdit(tour)}
                    style={{
                      padding: "0.5rem 1rem",
                      background: "#f97316",
                      border: "none",
                      borderRadius: "0.5rem",
                      color: "#111827",
                      cursor: "pointer",
                      fontWeight: "600",
                    }}
                  >
                    Uredi
                  </button>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

